import { Loadable } from '../../components/common/loadable/loadable';

export const JobsLazyContainer = Loadable<any>({
  loader: () =>
    import(/* webpackChunkName: "jobs" */ './jobs').then(
      (module) => module.default,
    ),
});
